import script from "./CrmContactDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrmContactDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./CrmContactDrawer.vue?vue&type=style&index=0&id=771b5e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771b5e3e"]])

export default __exports__